import initialStateSubscribable from '@/shared/mixins/store/subscribableData/initialState';

import { ActivitiesGpsState } from './types';

export default function initialState(): ActivitiesGpsState {
  return {
    ...initialStateSubscribable(),
  };
}
